import React from 'react';
import { Check, PenLine } from 'lucide-react';

/** Exercise row icon; inline exercises show a small “i” badge at top-left without resizing the icon. */
export const LessonExerciseHierarchyIcon: React.FC<{
  inline?: boolean;
  className?: string;
  showPassTick?: boolean;
  /** When true, render only the glyph (tooltip supplied by parent HierarchyIconBadge). */
  bare?: boolean;
}> = ({ inline = false, className = '', showPassTick = false, bare = false }) => {
  const icon = (
    <>
    <PenLine className="h-full w-full text-stone-700 dark:text-stone-300" aria-hidden />
    {inline ? (
      <span
        className="pointer-events-none absolute -left-0.5 -top-0.5 flex h-[10px] w-[10px] items-center justify-center rounded-full bg-amber-600 text-[8px] font-bold leading-none text-white ring-1 ring-white dark:ring-stone-900"
        aria-hidden
      >
        i
      </span>
    ) : null}
    {showPassTick ? (
      <span
        className="pointer-events-none absolute -right-0.5 -top-0.5 flex h-[10px] w-[10px] items-center justify-center rounded-full bg-green-600 text-white ring-1 ring-white dark:ring-stone-900"
        aria-hidden
      >
        <Check className="h-2 w-2" strokeWidth={3} />
      </span>
    ) : null}
    </>
  );

  if (bare) {
    return (
      <span className={`relative inline-flex h-4 w-4 shrink-0 items-center justify-center ${className}`}>
        {icon}
      </span>
    );
  }

  return (
    <span
      data-tooltip={inline ? 'Inline exercise' : 'Exercise'}
      className={`tooltip relative inline-flex h-4 w-4 shrink-0 items-center justify-center ${className}`}
      title={inline ? 'Inline exercise' : 'Exercise'}
    >
      {icon}
    </span>
  );
};
